<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <card>
          <div slot="header">
            <h4 class="card-title">LINE訂單推播群組設定 - {{shopName}}</h4>
          </div>

          <div v-if="user.type === 'gaa'">
            <p>說明：</p>
            <ul>
              <li>1. 請先建立好要給店家的 LINE群組</li>
              <li>2. 輸入此LINE群組名稱，供後續管理識別</li>
              <li>3. 點擊按鈕<span style="color:#00BA00;">「選擇LINE群組並進行綁定」</span>後，跳轉登入LINE帳號，選擇剛剛建立好要給店家的群組並儲存。</li>
              <li><b style="color:#BA0000;">4. LINE Notify官方帳號將自動被加入為好友，請邀請此官方帳號到建立好的群組</b></li>
              <li>5. 設定完畢，將此LINE群組提供給店家</li>
            </ul>

            <fg-input
              label="群組識別名稱"
              required
              v-model="model.name"
              v-validate="'required|max:20'"
              :error="getError('full name')"
              name="full name"
              placeholder="我的店家"
            ></fg-input>
            <fg-input
              label="群組加入網址"
              required
              v-model="model.url"
              v-validate="'required|max:100'"
              :error="getError('line group url')"
              placeholder="https://line.me/R/ti/g/YOUR_GROUP"
              name="line group url"
            ></fg-input>
          </div>
          <div v-else-if="user.type === 'eaa'">
            <p>說明：</p>
            <ul>
              <li>1. 請先建立好 LINE群組</li>
              <li>2. 輸入此LINE群組名稱，供後續管理識別</li>
              <li>3. 點擊按鈕<span style="color:#00BA00;">「選擇LINE群組並進行綁定」</span>後，跳轉登入LINE帳號，選擇剛剛建立好的群組並儲存。</li>
              <li><b style="color:#BA0000;">4. LINE Notify官方帳號將自動被加入為好友，請邀請此官方帳號到建立好的群組</b></li>
              <li>5. 設定完畢，即可開始接收訂單通知</li>
            </ul>

            <fg-input
              label="群組識別名稱"
              required
              v-model="model.name"
              v-validate="'required|max:20'"
              :error="getError('full name')"
              name="full name"
              placeholder="我的店家"
            ></fg-input>
          </div>
          <div class="d-flex justify-content-center">
            <n-button
              native-type="submit"
              @click.native.prevent="validate"
              type="success"
            >選擇LINE群組並進行綁定</n-button>
          </div>
        </card>
        <card>
          <div slot="header">
            <h4 class="card-title">目前推播群組</h4>
          </div>
          <div v-for="group in groups" :key="group.channelSubscriberId">
            <small>
              <p v-if="group.subscriberAttributes">Name: {{group.subscriberAttributes.name}}</p>
              <p class="text-info">ID: {{group.channelSubscriberId}}</p>
            </small>

            <b v-if="group.subscriberAttributes && group.subscriberAttributes.lineUrl !== 'undefined'">
              URL:
              <a :href="group.subscriberAttributes.lineUrl">{{group.subscriberAttributes.lineUrl}}</a>

              <br />
              <br />
            </b>

            <el-button @click="unsubscribe(group)">刪除此推播群組設定</el-button>

            <hr />
          </div>
        </card>
      </form>

      <!-- small modal -->
      <modal
        :show.sync="modals.mini"
        class="modal-danger"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </div>
        <p>
          <strong>{{modals.content}}</strong>
        </p>
        <template slot="footer">
          <!-- <n-button type="neutral" link>Back</n-button> -->
          <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Checkbox, Radio } from "src/components/index";
import { Modal } from "src/components";
// import CryptoJS from "crypto-js";

export default {
  components: {
    Checkbox,
    Radio,
    Modal
  },
  data() {
    return {
      groups: [],
      shopId: null,
      model: {
        // email: "",
        // password: "",
        name: ""
      },
      shopName: "",
      modelValidations: {
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        }
      },
      modals: {
        content: "",
        mini: false
      }
    };
  },
  mounted() {
    let self = this;
    if (this.$route.query.shop_id) {
      this.updateGroups();
      // return axios
      //   .get(
      //     `${process.env.VUE_APP_APIHOST}/gaa/line-notify-groups?shop_id=${this.$route.query.shop_id}`
      //   )
      //   .then(response => {
      //     this.groups = response.data;
      //     // console.log('the response ' + JSON.stringify(response.data));
      //     // self.model.email = response.data.email;
      //     // self.model.name = response.data.name;
      //     return response.data;
      //   })
      //   .catch(e => {
      //     if (e && e.data && e.data.message)
      //       this.modals.content = e.data.message;

      //     this.modals.mini = true;
      //   });
    }
    if (this.$route.query.shop_name)
      this.shopName = this.$route.query.shop_name;
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    updateGroups() {
      console.log("what the getter get " + JSON.stringify(this.user));
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/line-notify-groups?shop_id=${this.$route.query.shop_id}`
        )
        .then(response => {
          this.shopId = this.$route.query.shop_id;
          this.groups = response.data;
          // console.log('the response ' + JSON.stringify(response.data));
          // self.model.email = response.data.email;
          // self.model.name = response.data.name;
          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = e.data.message;

          this.shopId = null;
          this.modals.mini = true;
        });
    },
    windowClosing() {
      this.updateGroups();
      this.model.name = "";
      this.model.url = "";
    },
    unsubscribe(group) {
      let self = this;
      console.log("post and unsubscribe " + JSON.stringify(group));
      return axios
        .post(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/line-notify-groups/unsubscribe`,
          {
            shopId: this.$route.query.shop_id,
            accessToken: group.channelSubscriberId
          }
        )
        .then(response => {
          console.log("gogo unsubscribe done ", response);
          self.updateGroups();
          return;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = e.data.message;

          this.modals.mini = true;
        });
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid && this.shopId) {
          let qs;
          if (this.model.url) {
            qs = encodeURI(
              `?shop=${this.$route.query.shop_id}&channelName=${this.model.name}&groupUrl=${this.model.url}`
            );
          } else {
            qs = encodeURI(
              `?shop=${this.$route.query.shop_id}&channelName=${this.model.name}`
            );
          }

          // https://dl.gl/J4wnJROdR?shop=56
          // staging: `https://dl.gl/J4wnJROdR${qs}`,
          // tdev: https://dl.gl/aNXZpOn3v
          var newWindow = window.open(
            `${process.env.VUE_APP_APIHOST}/line-notify-binding${qs}`,
            // `${process.env.VUE_APP_TEMPOAUTH}${qs}`,
            // `https://dl.gl/J4wnJROdR?shop=${this.$route.query.shop_id}&channelName=${this.model.name}&groupUrl=${this.model.url}`,
            "line-notify-setting",
            "location=no,width=500px"
          );
          // for same origin
          // newWindow.onbeforeunload = this.windowClosing;

          let self = this;
          // for cross origin
          var timer = setInterval(function() {
            if (newWindow.closed) {
              clearInterval(timer);
              self.windowClosing();
            }
          }, 1000);

          // if (this.$route.params.gaaId) {
          //   // update
          //   return axios
          //     .put(
          //       `${process.env.VUE_APP_APIHOST}/gaa/gaa-users/${this.$route.params.gaaId}`,
          //       {
          //         email: this.model.email,
          //         name: this.model.name,
          //         password: this.model.password
          //       }
          //     )
          //     .then(response => {
          //       if (response && response.data && response.data.id) {
          //         this.$router.push("/gaa-users");
          //       } else {
          //         this.modals.content = "建立帳號發生錯誤";
          //         this.modals.mini = true;
          //       }
          //       return response.data;
          //     })
          //     .catch(e => {
          //       if (e && e.data && e.data.message)
          //         this.modals.content = e.data.message;

          //       this.modals.mini = true;
          //     });
          // } else {
          //   return axios
          //     .post(`${process.env.VUE_APP_APIHOST}/gaa/gaa-users/`, {
          //       email: this.model.email,
          //       name: this.model.name,
          //       password: this.model.password
          //     })
          //     .then(response => {
          //       if (response && response.data && response.data.id) {
          //         this.$router.push("/gaa-users");
          //       } else {
          //         this.modals.content = "建立帳號發生錯誤";
          //         this.modals.mini = true;
          //       }
          //       return response.data;
          //     })
          //     .catch(e => {
          //       if (e && e.data && e.data.message)
          //         this.modals.content = e.data.message;

          //       this.modals.mini = true;
          //     });
          // }
        } else {
          console.log("validate failed");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
};
</script>
<style>
.card .alert {
  position: relative !important;
  width: 100%;
}
</style>